import React, { useState } from "react";
import { Heart } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function WishlistButton({ productSlug, size = 20 }) {
  const { user } = useAuth();
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [askEmail, setAskEmail] = useState(false);
  const [email, setEmail] = useState("");

  const doAdd = async (targetEmail) => {
    setSaving(true);
    try {
      await api.post("/wishlist/add", { product_slug: productSlug, email: targetEmail });
      setSaved(true);
      toast.success("Added to wishlist", {
        description: "We'll email you when it's low or back in stock.",
      });
    } catch {
      toast.error("Couldn't save");
    } finally {
      setSaving(false);
      setAskEmail(false);
    }
  };

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (user?.email) return doAdd(user.email);
    setAskEmail(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={onClick}
        disabled={saving || saved}
        data-testid="wishlist-btn"
        title={saved ? "Saved" : "Save to wishlist"}
        className="inline-flex items-center justify-center h-9 w-9 border border-white/15 bg-black/70 backdrop-blur hover:border-[#FF5A1F] transition-colors"
      >
        <Heart size={size} weight={saved ? "fill" : "regular"} color={saved ? "#FF5A1F" : "#ffffff"} />
      </button>
      {askEmail && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="fixed inset-0 z-[85] flex items-center justify-center bg-black/80 backdrop-blur p-4"
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (email) doAdd(email);
            }}
            className="w-full max-w-sm border border-white/15 bg-[#0d0d0d] p-6"
          >
            <div className="font-label text-xs text-[#FF5A1F]">/ SAVE FOR LATER</div>
            <div className="mt-2 font-display text-2xl font-black">Where should we send restock alerts?</div>
            <input
              type="email"
              required
              autoFocus
              placeholder="you@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-4 w-full border border-white/15 bg-black px-4 py-3 text-sm outline-none focus:border-[#FF5A1F]"
            />
            <div className="mt-4 flex gap-2">
              <button
                type="button"
                onClick={() => setAskEmail(false)}
                className="border border-white/20 px-4 py-2 font-label text-xs text-white/60"
              >
                Cancel
              </button>
              <button
                disabled={saving}
                className="flex-1 bg-[#FF5A1F] py-2 font-label text-xs text-black hover:-translate-y-0.5 transition-transform disabled:opacity-60"
              >
                {saving ? "Saving..." : "Save to wishlist"}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
